<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner />
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'groups.index' }">
                    {{ $t('Groups') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ id ? item.originalData.name : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="id"
                id="item_actions_dropdown"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width />
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width />
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>
        <b-card class="mb-3" no-body tag="section">
            <b-form
                @submit.prevent="handleSave"
                @keydown="item.onKeydown($event)"
            >
                <b-card-body>
                    <b-form-group
                        :label="$t('Name')"
                        label-for="name"
                        :state="item.errors.has('name') ? false : null"
                        :invalid-feedback="item.errors.get('name')"
                    >
                        <b-form-input
                            id="name"
                            v-model="item.name"
                            :state="item.errors.has('name') ? false : null"
                            autofocus
                            name="name"
                        />
                    </b-form-group>

                    <b-form-row>
                        <b-col sm="auto" order-sm="1">
                            <b-form-group
                                :label="$t('Filter by role')"
                                label-for="role"
                            >
                                <b-form-select
                                    id="role"
                                    v-model="role"
                                    name="role"
                                    :options="userRoles"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group
                                :label="$t('Users')"
                                label-for="Users"
                                :state="item.errors.has('users') ? false : null"
                                :invalid-feedback="item.errors.get('users')"
                            >
                                <resource-select
                                    id="users"
                                    v-model="item.users"
                                    class="w-auto flex-grow-1"
                                    multiple
                                    name="users"
                                    :resource="`users`"
                                    :resource-params="{role}"
                                    :state="item.errors.has('users') ? false : null"
                                />
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </b-card-body>

                <b-card-footer>
                    <b-button
                        :disabled="item.busy"
                        type="submit"
                        variant="primary"
                    >
                        {{ id ? $t('Save') : $t('Create') }}
                        <b-spinner v-show="item.busy" small />
                    </b-button>
                </b-card-footer>
            </b-form>
        </b-card>
    </main>
</template>

<script>
    import itemMixin from "@/mixins/itemMixin";
    import ResourceSelect from "@/components/selects/ResourceSelect";
    import {USER_ROLES} from "@/constants";

    export default {
        name: 'Group',
        components: {ResourceSelect},
        mixins: [itemMixin],
        data() {
            return {
                role: null
            }
        },
        computed: {
            resourceName() {
                return 'groups';
            },

            userRoles() {
                return [
                    {
                        value: null,
                        text: this.$t('All roles')
                    }
                ].concat(Object.values(USER_ROLES).map(role => {
                    return {
                        value: role,
                        text: this.$t(role),
                    }
                })
                )
            }

        },
    };
</script>
